
import type { PropType } from 'vue'
import type { EpbBaseInputSize } from '../epb-base-input/epb-base-input.types'
import { defineComponent } from 'vue'
import { EpbText } from '../epb-text'

export default defineComponent({
  name: 'EpbInputLabel',
  components: {
    EpbText,
  },
  props: {
    text: {
      type: String,
      default: undefined,
    },
    icon: {
      type: String,
      default: undefined,
    },
    size: {
      type: String as PropType<EpbBaseInputSize>,
      default: 'md',
    },
    required: Boolean,
    error: Boolean,
  },
  setup() {
    const baseClass = 'epb-input-label'

    return {
      baseClass,
    }
  },
})
